module.exports = __webpack_public_path__ + "img/ribbon-design.c244ac05.svg";